<template>
  <div id="main" class="app-main">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      theme: this.$store.state.app.themeColor,
    };
  },
  async created() {
    console.log("app start.");
    // !获取配置
    let res = await $utils.api.load("siteconfig", {}, "post", {
      toast: false,
      toasterror: false,
      loading: false,
      loadingtext: "Loading",
      login: false,
    });
    if (res) {
      if (res.data) {
        console.log("siteconfig", res);
        const title =
          (res.data && res.data.base_appname && res.data.base_appname.value) ||
          "";
        $utils.data.set("siteconfig", "appname", title);
        console.log("appname settitle", title);
        this.$store.commit("setTitle", title);
      }
    }
    // !检测登录状态
    res = await $utils.api.load("authCheck", {}, "post", {
      toast: false,
      toasterror: false,
      loading: false,
      loadingtext: "Loading",
      login: false,
    });
    if (res) {
      if (res.code != 1) {
        // 登录
        $utils.url.push({ name: "login" });
        return false;
      }
      if (res.data && res.data.auths) {
        const last_login_time = $utils.time.format(
          res.data.last_login_time || ""
        );
        $utils.data.set("auth", "last_login_time", last_login_time);
        $utils.data.set("auth", "auths", []);
        $utils.data.set("auth", "username", res.data.username);
        $utils.data.set("auth", "uid", res.data.uid);
        $utils.data.set("auth", "uname", res.data.uname);
        $utils.data.set("auth", "mobile", res.data.user_mobile);
        $utils.data.set(
          "auth",
          "avatar",
          $utils.image.load(res.data.head) ||
            require("@/assets/img/useravatar.jpg")
        );
        $utils.data.set("auth", "auths", res.data.auths);
        $utils.data.set("auth", "is_system", res.data.is_admin);
        $utils.data.set("auth", "is_admin", res.data.is_admin);
        // 强制刷新页面 否则左侧路由无法更新
        this.$store.commit("updateMenulist");
      } else {
        $utils.toast.error(res.message);
      }
    }
  },
  mounted() {},
  methods: {},
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  overflow: hidden;
}
.app-main {
  width: 100%;
  height: 100%;
}
</style>
